import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IUserDataSchema } from '../../../repositories/journal/entities/user/UserDataSchema';

export enum ESetUserDataActionType {
  Set = 'user/setUserData/set',
}

export type TUserData = ITypedReduxAction<ESetUserDataActionType.Set, IUserDataSchema>;
